<script>
  import TrendChart from './TrendChart.vue';

  export default {
    name: 'TestsPerMonth',
    extends: TrendChart,
    data() {
      return {
        chartId: 'testsPerMonth',
        fields: [
          'tests_ige',
          'tests_mqt',
          'tests_pricks',
          'tests_sticks',
        ],
      };
    },
  };
</script>
